<!--铃音录制页面-->
<template>
    <div class="hello" >
        <div  class="w100 pos_re">
            <!-- <img src="../../static/img/ringone_banner.jpg" class="w100 banner_img"> -->
        </div>
        <div class="w100">
            <div class="content" style="margin-top:5vw">
                <div class="w100 dis_column ali_cen">
                    <p class="con_title">录制流程</p>
                    <p class="con_title_des">RECORDING PROCESS</p>
                    <div class="dis_row ali_cen just_cen">
                        <p class="con_title_line"></p>
                        <img src="../../static/img/index/con_title_img.png" class="con_title_img">
                        <p class="con_title_line"></p>
                    </div>
                    <div class="dis_row just_bet margin_top_2" style="width:60vw">
                        <div class="process_bgc bgc_f2f0f2 dis_row just_cen ali_cen">
                            <!-- <img src="../../static/img/ringoneRecord/synopsis_1.png" class="process_img"> -->
                        </div>
                        <div class="process_detail"></div>
                    </div>
                </div>
            </div>
            <div class="content" style="margin-top:5vw;margin-bottom:5vw">
                <div class="w100 dis_column ali_cen">
                    <p class="con_title">服务优势</p>
                    <p class="con_title_des">SERVICE ADVANTAGES</p>
                    <div class="dis_row ali_cen just_cen">
                        <p class="con_title_line"></p>
                        <img src="../../static/img/index/con_title_img.png" class="con_title_img">
                        <p class="con_title_line"></p>
                    </div>
                    <div class="dis_row just_bet margin_top_2" style="width:60vw">
                        <!-- <img src="../../static/img/ringoneRecord/synopsis.png" style="width:57vw"> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {titleList} from '../assets/js/global.js'
export default {
    name: 'video_ringone',
    data () {
        return {
            
        }
    },
    created(){
        document.documentElement.scrollTop = document.body.scrollTop = 0;
        this.$root.indexTabFlag = 0;
        titleList(this.$root.indexTabList,1)
    },
    mounted () {
        window.addEventListener('scroll', this.scrollToTop)
    },
    destroyed () {
        window.removeEventListener('scroll', this.scrollToTop)
    },
    methods:{
        scrollToTop(){
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            if(scrollTop > 100){
                this.$root.indexTabFlag = 1
            }else{
                this.$root.indexTabFlag = 0
            }
        }
    }
}
</script>
<style scoped>
    .banner_img{
        width: 100%;
        height: 31vw;
        /* margin-top: 3.4vw; */
    }
    .bgc_f2f0f2{
        background-color: #f2f0f2;
    }
    .process_bgc{
        position: absolute;
        width: 100vw;
        left: 0;
        top: 42.5vw;
        right: 0;
        height: 30vw;
    }
    .process_img{
        height: 25vw;
    }
    .process_detail{
        width: 100%;
        height: 30vw;
    }
</style>



// WEBPACK FOOTER //
// src/components/RingoneRecord.vue